import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "./components/ui/card";
import { Label } from "./components/ui/label";
import { Input } from "./components/ui/input";
import { Textarea } from "./components/ui/textarea";

export const ClientSection = ({ t, formData, setFormData, validationErrors }) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      client: {
        ...prev.client,
        [name]: value
      }
    }));
  };
  

  const getInputClassName = (fieldPath) => {
    return `${validationErrors[fieldPath] ? 'border-red-500' : ''}`
  };

  const renderInput = (name, label, type = "text", required = false) => (
    <div>
      <Label className="flex items-center">
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </Label>
      <Input
        name={name}
        value={formData.client[name]}
        onChange={handleChange}
        type={type}
        className={getInputClassName(`client.${name}`)}
      />
      {validationErrors[`client.${name}`] && (
        <p className="text-red-500 text-sm mt-1">
          {validationErrors[`client.${name}`]}
        </p>
      )}
    </div>
  );

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t.client.title}</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          {/* Basic Company Information */}
          <div className="space-y-4">

            {renderInput('company', t.client.company, 'text', true)}
            {renderInput('street', t.client.street, 'text', true)}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {renderInput('zipCode', t.client.zipCode, 'text', true)}
              {renderInput('city', t.client.city, 'text', true)}
            </div>
          </div>

          {/* Registration Information */}
          <div className="space-y-4">
            {renderInput('registration', t.client.registration, 'text')}
            {renderInput('vatId', t.client.vatId, 'text')}    
            {renderInput('representative', t.client.representative, 'text')}
          </div>

          {/* Contract Contact Person */}
          <div className="space-y-4">
            <h3 className="font-bold text-lg">{t.client.contractContact}</h3>
            {renderInput('contractContactName', t.client.contactName, 'text', true)}
            {renderInput('contractContactPhone', t.client.contactPhone, 'tel')}
            {renderInput('contractContactEmail', t.client.contactEmail, 'email', true)}
          </div>

          {/* Technical Contact Person */}
          <div className="space-y-4">
            <h3 className="font-bold text-lg">
              {t.client.technicalContact}
              <span className="text-gray-500 text-sm font-normal ml-2">
                {t.client.optional}
              </span>
            </h3>
            <p className="text-sm text-gray-500 italic">
              {t.client.technicalContactHint}
            </p>
            {renderInput('technicalContactName', t.client.contactName, 'text')}
            {renderInput('technicalContactPhone', t.client.contactPhone, 'tel')}
            {renderInput('technicalContactEmail', t.client.contactEmail, 'email')}
          </div>

          {/* Billing Address */}
          <div>
            <Label>{t.client.billingAddress}</Label>
            <Textarea
              name="billingAddress"
              value={formData.client.billingAddress}
              onChange={handleChange}
              placeholder={t.client.billingAddressPlaceholder}
              rows={3}
            />
          </div>
        </div>
      </CardContent>
    </Card>
  );
};